<script lang="ts">
  import type { BrushMode, BrushSettings } from '../depth/brush';
  import { t } from '../i18n/index.svelte';

  let {
    enabled = $bindable(),
    settings = $bindable(),
    canUndo,
    hasEdits,
    onundo,
    onclear,
    version = 0,
  }: {
    enabled: boolean;
    settings: BrushSettings;
    canUndo: boolean;
    hasEdits: boolean;
    onundo: () => void;
    onclear: () => void;
    version?: number;
  } = $props();

  const modes: BrushMode[] = ['raise', 'lower', 'smooth', 'flatten'];
</script>

<div class="brush row" data-version={version}>
  <button
    class:active={enabled}
    onclick={() => (enabled = !enabled)}
    data-testid="brush-toggle"
    title={t('brush.hint')}
  >
    🖌 {t('brush.title')}
  </button>
  {#if enabled}
    <div class="seg">
      {#each modes as m (m)}
        <button class:on={settings.mode === m} onclick={() => (settings.mode = m)} data-testid={`brush-${m}`}
          >{t(`brush.${m}`)}</button
        >
      {/each}
    </div>
    <label class="mini" title={t('brush.radius')}>
      ⌀ <input type="range" min="4" max="200" bind:value={settings.radius} />
    </label>
    <label class="mini" title={t('brush.strength')}>
      ◐ <input type="range" min="0.05" max="1" step="0.05" bind:value={settings.strength} />
    </label>
    <button disabled={!canUndo} onclick={onundo} title={t('brush.undo')} data-testid="brush-undo">↶</button>
    <button disabled={!hasEdits} onclick={onclear} title={t('brush.clear')}>✕</button>
  {/if}
</div>

<style>
  .brush {
    gap: 6px;
  }
  .active {
    border-color: var(--accent);
    color: var(--accent);
  }
  .mini {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: var(--muted);
  }
  .mini input {
    width: 70px;
  }
  .seg button {
    font-size: 12px;
  }
</style>
